// export const baseURL = 'http://115.190.111.104:8081'
export const baseURL = 'https://lbs-consulting.com/api'

export const imgURL = 'https://lbs-consulting.com'
